import Container from '@material-ui/core/Container';
import React from 'react';
import { connect } from 'react-redux';
import Logo from '../../components/Logo/Logo';
import DrawerRindegastos from '../Drawer/DrawerRindegastos';
import classes from './Dashboard.module.css';
import Logout from '../../containers/Auth/Logout/Logout';

const Dashboard = props => {

	return (
		<div className={classes.root}>
			<DrawerRindegastos />
			<header className={classes.headerRindegastos} role="banner">
				<div>
					<Logo />
				</div>
				<div className={classes.logOutContainer}>
					<Logout />
				</div>
			</header>
			<main className={classes.main}>
				<Container className={classes.mainContent}>{props.children}</Container>
			</main>
		</div>
	);
};

const mapStateToProps = state => {
	return {
		isAuthenticated: state.auth.token !== null,
	};
};

export default connect(mapStateToProps)(Dashboard);
